import DeviceContainer from './DeviceContainer';
import DeviceInfo from './DeviceInfo';
import DeviceList from './DeviceList'

export default {
    DeviceContainer,
    DeviceInfo,
    DeviceList
}

